// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2fp_n0ud4EP8hB2LbJuKNH"};